import React, {useState, useEffect} from 'react'
import { languages } from '../utility/constants'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { socket } from '../../socket';
import { captiliseText } from '../utility/MessageFormatter';
import { setCookie, updateCookie, getCookie } from '../utility/cookies';

const SelectLang = ({ filterLang, botInfo, setOpenFeedback, setNoFeedback, prefLang, setPrefLang, isLang, setIsLang}) => {
    let language = languages
    const settings = {
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 0,
      arrows:false,
      autoplay:true
      
    };
    const windowGroupId = process.env.REACT_APP_PROD === "true" ? window.chat_widget_reference_no : process.env.REACT_APP_GROUPID

    const [prefTextChange, setPrefTextChange] = useState(null)
    var onevent = socket.onevent;
    useEffect(()=>{
        if(botInfo.data.mobileAppConfig.preferredLanguage){
          let val = [];
          for (let [key, value] of Object.entries(botInfo.data.mobileAppConfig.preferredLanguage)) {
            
            val.push(value)
            
            
              // console.log("values ,,,,",val);
          }
          setPrefTextChange(val)
        }
        else{
          let val = "en";
          setPrefTextChange(val)
        }
        
        

    },[botInfo])
    
    // console.log("printing , ", prefLangText)
    // console.log("values ,,,,1",prefTextChange);
    console.log("check array 12345", filterLang)
    // console.log("print the ")

    function generateRandomString() {
      const now = new Date();
      const timestamp = now.getTime();
      const randomNumber = Math.floor(Math.random() * 1000000);
      const randomString = `${timestamp}${randomNumber}`;
      return randomString;
    }
  return (
    <div className='landing-language-page'>
      <div className='select-langauge-section'  style={{color: botInfo?.appInfo?.cHeaderText}}>
      <Slider {...settings}>
      
        {
            prefTextChange?.map(lang=>{
            return <h3 key={lang}>{lang}</h3>
            
            })}
      </Slider>
{/*        
        <h2>Preferred Language</h2> */}
        <div className='language-wrapper'>
        {
          filterLang?.map(lang=>{
              return (
                <div className="lang-box" key={lang.val} onClick={()=>{setPrefLang(lang.value);
                  updateCookie('prefLang', lang.value);
                  setIsLang(true);
                  console.log("updating isLAng 4", isLang)
                  updateCookie('firstLang', lang.value)
                  updateCookie('appState', 'langSet')
                  socket.disconnect()
                  let newSessionId = ''
                  if (getCookie('sessionId')) {
                      newSessionId = getCookie('sessionId')
                  }else {
                      newSessionId = generateRandomString()
                      updateCookie("sessionId", newSessionId)
                  }
                  const botType = process.env.REACT_APP_PROD === "true" ? window.bot_type : process.env.REACT_APP_TYPE
                  if(botType === "TlkDocs"){
                      socket.io.opts.query = 'type=user&page=chat&locale=' + lang.value + '&group=' + windowGroupId +'&session_id='+ window.sessionId +'&platform=talkkmesanger'+'&EIO=3&transport=websocket';
                  }else{
                      socket.io.opts.query = 'type=user&page=chat&locale=' + lang.value + '&group=' + windowGroupId +'&session_id='+ newSessionId + '&EIO=3&transport=websocket';
                  }
                  socket.connect()
                
                   }} >
                  <p className="lang-name">{captiliseText(lang.value)}</p>
                  <p >{captiliseText(lang.label)}</p>
                </div>
              )
              })
          }
            {/* <li><button type="submit" onClick={()=>{setPrefLang('fr');setIsLang(true)}}><p>FR</p><p>Francais</p></button></li>
            <li><button type="submit" onClick={()=>{setPrefLang('kr');setIsLang(true)}}><p>KR</p><p>Kreal</p></button></li> */}
        </div>
      </div>
    </div>
  )
}

export default SelectLang
